export default __webpack_public_path__ + "static/media/faq-gradient.16579c8b.png";